import { createStyles } from '@mantine/styles';

export const useCommonStyles = createStyles(theme => ({
    // Sidebar(planner, drive menu) 탭 아이템 호버 및 선택 상태 스타일
    mainSidebarItem: {
        borderRadius: '8px',
        '&:hover': {
            borderRadius: '8px',
            backgroundColor: theme.colors.gray[4],
            boxShadow:
                '0px 1px 3px 0px rgba(0, 0, 0, 0.051), 0px 1px 2px 0px rgba(0, 0, 0, 0.102)',
        },
        '&[data-active="true"]': {
            borderRadius: '8px',
            backgroundColor: theme.colors.gray[4],
            boxShadow:
                '0px 1px 3px 0px rgba(0, 0, 0, 0.051), 0px 1px 2px 0px rgba(0, 0, 0, 0.102)',
        },
    },

    // SecondarySidebar(보고서, 피드백 탭) 탭 아이템 호버 및 선택 상태 스타일
    secondarySidebarItem: {
        borderRadius: '8px',
        '&:hover': {
            borderRadius: '8px',
            backgroundColor: theme.fn.rgba('#868E96', 0.1),
        },
        '&[data-active="true"]': {
            borderRadius: '8px',
            backgroundColor: theme.fn.rgba('#868E96', 0.1),
        },
    },
}));

export const backToAppTextStyle: React.CSSProperties = {
    color: '#70797B',
    fontFamily: 'Pretendard',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    cursor: 'pointer',
    padding: '8px 8px',
};

// SecondarySidebar Tabs.List 공통 스타일
export const sidebarTabsListStyle: React.CSSProperties = {
    gap: '2px',
    padding: '0 0.5rem',
};

// SecondarySidebar Tabs.List 공통 props (width와 style을 함께 관리)
export const sidebarTabsListProps = {
    w: '100%' as const,
    style: sidebarTabsListStyle,
};
